export default __webpack_public_path__ + "static/media/ic_hiring.a9d185fd.svg";